package com.swetdot.swetgram.data

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

/**
 * The contract types `client_id` and `Idempotency-Key` as `format: uuid`, so these must be real
 * UUIDs rather than any unique string -- the server validates the format.
 *
 * `kotlin.uuid` is still experimental, so the opt-in is confined to this one file instead of
 * being sprinkled across the data layer.
 */
@OptIn(ExperimentalUuidApi::class)
fun newUuid(): String = Uuid.random().toString()
